import React from 'react';
import { ImageIcon } from '@fluentui/react/lib/Icon';
import { registerIcons } from '@fluentui/style-utilities';
import type { AddinCommandSurfaceItem } from 'owa-addins-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { makeStyles } from '@fluentui/react-components';

const AddinIcons = new Set<string>();

const preventContextMenu = (ev: React.MouseEvent<HTMLElement>) => {
    ev.preventDefault();
    ev.stopPropagation();
};

type ImageIconProps = {
    iconName: string;
    iconUrl: string;
};

export function getAddinIcon(
    addIn: AddinCommandSurfaceItem,
    isMenuItem: boolean = false
): string | undefined {
    const encodeRegisterKey = (surfaceAddIn: AddinCommandSurfaceItem) =>
        `AddIn_${(isGlobalFeatureEnabled('addin-ribbonDesignPhase1')
            ? surfaceAddIn?.id ?? surfaceAddIn?.name
            : surfaceAddIn?.name
        )?.replace(/\s/g, '_')}`;
    const iconName = encodeRegisterKey(addIn);

    if (!AddinIcons.has(iconName)) {
        if (!addIn?.iconProps || !addIn.iconProps?.imageProps || !addIn.iconProps.imageProps?.src) {
            return undefined;
        }

        const iconUrl = addIn.iconProps.imageProps.src;

        const imageProps = {
            ...addIn.iconProps?.imageProps,
            // Sensible overrides for the image icons to match other ribbon's font icon buttons.
            width: '85%',
            height: '85%',
        };

        const Icon = () => {
            return isGlobalFeatureEnabled('mon-ribbon-fluent-v9-menus') && isMenuItem ? (
                <ImageIconWrapper iconName={iconName} iconUrl={iconUrl} />
            ) : (
                <ImageIcon imageProps={imageProps} onContextMenu={preventContextMenu} />
            );
        };

        registerIcons({
            icons: {
                [iconName]: <Icon />,
            },
        });

        AddinIcons.add(iconName);
    }

    return iconName;
}

const v9Styles = makeStyles({
    wrapper: {
        width: '18px',
        height: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    img: {
        width: '85%',
        height: '85%',
        objectFit: 'contain',
    },
});

/**
 * TODO: 404097 and 401941
 * Fluent V9 doesn't support ImageIcon. As a result, the styles we're sending aren't taking in consideration.
 * Addins should create SVGs or look for an alternative on the current set of icons,
 * to follow the pattern we have in all of our buttons, except these ones.
 * As a result, adding a wrapper on V9 rendering, which outputs similar content of ImageIcon, and also allowing us to
 * align each menu icon vertically
 */
const ImageIconWrapper: React.FC<ImageIconProps> = ({ iconName, iconUrl }) => {
    const v9IconStyles = v9Styles();
    return (
        <div className={v9IconStyles.wrapper} onContextMenu={preventContextMenu}>
            <img src={iconUrl} className={v9IconStyles.img} alt={iconName} />
        </div>
    );
};
